/**
 * Licensed Materials - Property of IBM
 *
 * IBM Cognos Products: Dashboard
 *
 * Copyright IBM Corp. 2015, 2019
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([
	'../../lib/@waca/core-client/js/core-client/ui/core/View',
	'underscore'
], function(View, _) {


	var BaseTab = View.extend({
		//Class fields
		properties:null,

		init: function(options) {
			BaseTab.inherited('init', this, arguments);
			_.extend(this, options);
		},

		render: function() {
			return Promise.resolve();
		},

		show: function(){
			if(!this.isShowing){
				this.isShowing = true;
				this.properties.$category = this.$el;
				this.properties._renderCategory(this.id);
			}
		},

		hide: function(){
			this.isShowing = false;
		}
	});

	return BaseTab;
});
